<template>
  <v-dialog 
    v-model="dialog" 
    width="750" 
    persistent>
    <v-card>
      <v-toolbar color="secondary">
        <v-alert
          :value="isExist || distanza !== null"
          :type="typeModale"
          transition="slide-x-transition"
          style="position: absolute; left: 0; top: 0; bottom: 0;"
          v-text="textModale"
        />
        <v-spacer/>
        <v-btn 
          :disabled="!valid" 
          color="primarytext" 
          flat 
          @click="onSaveClick">
          <v-icon left>save</v-icon>Crea
        </v-btn>
        <v-btn 
          icon 
          @click="$emit('on-close')">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-toolbar>
      <form 
        id="modal-tratta" 
        style="position: relative; width: 750px;">
        <v-toolbar 
          dense 
          floating 
          absolute 
          class="toolbar-ricerca" 
          style="top: 10px; left: 0">
          <v-expansion-panel
            :value="[isNewTratta(form.trattaDa)]"
            style="background-color: transparent"
            class="elevation-0"
            expand
          >
            <v-expansion-panel-content 
              class="pa-0" 
              style="background-color: transparent">
              <template 
                slot="header" 
                style="padding: 0">
                <v-autocomplete
                  v-model="form.trattaDa"
                  :error-messages="errorMessage('trattaDa')"
                  :filter="filtering"
                  :items="itemsDa"
                  :loading="isLoadingDa"
                  :search-input.sync="searchDa"
                  :readonly="isLoadingDa"
                  prepend-icon="fas fa-map-marker-alt"
                  color="tree"
                  clearable
                  hide-no-data
                  hide-selected
                  item-text="descrizione"
                  item-value="lat"
                  label="Punto partenza"
                  placeholder="Punto partenza"
                  return-object
                >
                  <template slot="append-outer">
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon
                        v-if="!isLoadingA"
                        color="tree"
                        @click="searchPlaceHandler(searchDa, 'listTrDa', 'isLoadingDa')"
                      >search</v-icon>
                    </v-slide-x-reverse-transition>
                  </template>
                  <template 
                    slot="item" 
                    slot-scope="props">
                    <template>
                      <v-list-tile-avatar class="font-weight-medium">
                        <v-avatar 
                          :color="props.item.id !== -1 ? 'tree lighten-3' : 'red lighten-3'" 
                          size="36">
                          <span 
                            v-if="props.item.id === -1" 
                            class="white--text">API</span>
                          <span 
                            v-else 
                            class="white--text">DB</span>
                        </v-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="props.item.citta"/>
                        <v-list-tile-sub-title>{{ props.item.via }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </template>
              <v-card 
                v-if="isNewTratta(form.trattaDa)" 
                color="transparent">
                <v-text-field
                  v-model="form.trattaDa.citta"
                  box
                  color="tree"
                  label="Citta"
                  prepend-inner-icon="fas fa-building"
                />
                <v-text-field
                  v-model="form.trattaDa.via"
                  box
                  color="tree"
                  label="Via"
                  prepend-inner-icon="fas fa-archway"
                />
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-toolbar>
        <v-toolbar
          dense
          floating
          absolute
          class="toolbar-ricerca"
          style="top: 10px; right: 0; left: auto"
        >
          <v-expansion-panel
            :value="[isNewTratta(form.trattaA)]"
            style="background-color: transparent"
            class="elevation-0"
            expand
          >
            <v-expansion-panel-content 
              class="pa-0" 
              style="background-color: transparent">
              <template 
                slot="header" 
                style="padding: 0">
                <v-autocomplete
                  v-model="form.trattaA"
                  :error-messages="errorMessage('trattaA')"
                  :filter="filtering"
                  :items="itemsA"
                  :loading="isLoadingA"
                  :search-input.sync="searchA"
                  :readonly="isLoadingA"
                  prepend-icon="fas fa-map-marker-alt"
                  color="tree"
                  clearable
                  hide-no-data
                  hide-selected
                  item-text="descrizione"
                  item-value="lat"
                  label="Punto arrivo"
                  placeholder="Punto arrivo"
                  return-object
                >
                  <template slot="append-outer">
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon
                        v-if="!isLoadingA"
                        color="tree"
                        @click="searchPlaceHandler(searchA, 'listTrA', 'isLoadingA')"
                      >search</v-icon>
                    </v-slide-x-reverse-transition>
                  </template>
                  <template 
                    slot="item" 
                    slot-scope="props">
                    <template>
                      <v-list-tile-avatar class="font-weight-medium">
                        <v-avatar 
                          :color="props.item.id !== -1 ? 'tree lighten-3' : 'red lighten-3'" 
                          size="36">
                          <span 
                            v-if="props.item.id === -1" 
                            class="white--text">API</span>
                          <span 
                            v-else 
                            class="white--text">DB</span>
                        </v-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="props.item.citta"/>
                        <v-list-tile-sub-title>{{ props.item.via }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </template>
              <v-card 
                v-if="isNewTratta(form.trattaA)" 
                color="transparent">
                <v-text-field
                  v-model="form.trattaA.citta"
                  box
                  color="tree"
                  label="Citta"
                  prepend-inner-icon="fas fa-building"
                />
                <v-text-field
                  v-model="form.trattaA.via"
                  box
                  color="tree"
                  label="Via"
                  prepend-inner-icon="fas fa-archway"
                />
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-toolbar>

        <v-layout row>
          <v-flex>
            <HereMapRoute
              v-if="dialog"
              :zoom="10"
              :lng="map.lon"
              :lat="map.lat"
              :waypoint0="map.waypoint0"
              :waypoint1="map.waypoint1"
              :time-out="500"
              app-id="eLB4jmsueNDd1At2iSdC"
              app-code="plyNFw9vdDhpK3Ss74f8Ug"
              mode="fastest;car"
              ancore="modal-tratta"
            />
          </v-flex>
        </v-layout>
      </form>
      <Loading 
        :show="isLoadingDist" 
        label="Sto calcolando la distanza..."/>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import Loading from "./Loading.vue";
import HereMapRoute from "./MapHere/components/HereMapRoute.vue";

const formCampInit = {
  trattaDa: null,
  trattaA: null
};

const sortTr = (a, b) => {
  if (a.citta > b.citta) {
      return 1;
  }
  if (b.citta > a.citta) {
      return -1;
  }
  return 0;
}

export default {
  name: "AccModalTratta",
  components: { Loading, HereMapRoute },
  mixins: [validationMixin],
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  validations: {
    form: {
      trattaDa: { required },
      trattaA: { required }
    }
  },
  data: () => ({
    form: { ...formCampInit },
    distanza: null,
    isLoadingDa: false,
    isLoadingA: false,
    isLoadingDist: false,
    searchDa: "",
    searchA: "",
    listTrDa: [],
    listTrA: [],
    map: {
      lat: null,
      lng: null,
      waypoint0: null,
      waypoint1: null
    }
  }),
  computed: {
    isExist() {
      return (
        !this.isEmpty(this.form.trattaDa) &&
        !this.isEmpty(this.form.trattaA) &&
        ((this.form.trattaDa.id === this.form.trattaA.id && this.form.trattaDa.id !== -1) ||
          this.tratte.filter(tr => {
            return (
              tr.id_via_p == this.form.trattaDa.id &&
              tr.id_via_d == this.form.trattaA.id
            );
          }).length > 0)
      );
    },
    isErrato () {
      return !this.isEmpty(this.form.trattaDa) &&
        !this.isEmpty(this.form.trattaA) && (this.form.trattaDa.id === this.form.trattaA.id && this.form.trattaDa.id !== -1 )
    },
    valid () {
      return !!this.form.trattaDa && !!this.form.trattaA && !this.isExist
    },
    via() {
      return this.$store.getters["gestione/viaConCitta"];
    },
    tratte() {
      return this.$store.getters["gestione/tratte"];
    },
    itemsDa() {
      return this.listTrDa.filter(tr => (tr.id === -1 || (tr.eliminato == 0 && tr.citta_eliminata == 0)))
    },
    itemsA() {
      return this.listTrA.filter(tr => (tr.id === -1 || (tr.eliminato == 0 && tr.citta_eliminata == 0)))
    },
    textModale() {
      if (this.isErrato) {
        return "Non si può creare tratta";
      } else if (this.isExist) {
        return "Tratta esiste";
      } else if (this.distanza) {
        return this.distanza + " Km";
      }
    },
    typeModale() {
      if (this.isExist && this.form.trattaDa.id === this.form.trattaA.id) {
        return "error";
      } else if (this.isExist) {
        return "error";
      } else if (this.distanza) {
        return "success";
      }
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.cleanDialogForm();
        this.listTrDa = this.via.sort(sortTr);
        this.listTrA = this.via.sort(sortTr);
      }
    },
    "form.trattaDa"(val) {
      if (val && val.lat && val.lon) {
        this.map.lat = +val.lat;
        this.map.lng = +val.lon;
        this.map.waypoint0 = val.lat + "," + val.lon;
      }
    },
    "form.trattaA"(val) {
      if (val && val.lat && val.lon) {
        this.map.waypoint1 = val.lat + "," + val.lon;
      }
    },
    searchDa(val) {
      //      this.searchPlaceHandler(val, "listTrDa", "isLoadingDa");
    },
    searchA(val) {
      //      this.searchPlaceHandler(val, "listTrA", "isLoadingA");
    },
    map: {
      handler(val, old) {
        if (
          !this.isEmpty(val.waypoint0) &&
          !this.isEmpty(val.waypoint1) &&
          !this.isExist
        ) {
          this.searchDistanceHandler(val.waypoint0, val.waypoint1);
        } else {
          this.distanza = null;
        }
      },
      deep: true
    }
  },
  methods: {
    isNewTratta(obj) {
        return !this.isEmpty(obj) && obj.id === -1
    },
    isEmpty(obj) {
      if (!obj || JSON.stringify(obj) === JSON.stringify({})) return true;

      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
    },
    searchDistanceHandler(da, a) {
      this.isLoadingDist = true;
      this.$store
        .dispatch("gestione/searchDistance", { da, a })
        .then(res => {
          if (200 === res.status && res.ok && res.data.response) {
            this.distanza = res.data.response.route
              .map(r => (r.summary.distance / 1000).toFixed(0))
              .join(";");
          }
        })
        .catch(err => {
          console.log("Errore", err);
        })
        .finally(() => (this.isLoadingDist = false));
    },
    searchPlaceHandler(val, list, loading) {
      console.log('searchPlaceHandler', val, list, loading);
      
      if (!val) return;
      //      let listT = this[list].filter(v => {
      //        return (
      //          (v.citta && v.citta.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
      //          (v.via && v.via.toLowerCase().indexOf(val.toLowerCase()) > -1)
      //        );
      //      });
      // Items have already been loaded
      //      if (listT.length > 0 || this[loading]) return;
      if (this[loading]) return;

      this[loading] = true;

      // Lazily load input items
      this.$store
        .dispatch("gestione/searchPlace", val)
        .then(res => {
          if (200 === res.status && res.ok && res.data.results.length > 0) {
            let ft = res.data.results
              .filter(
                rs =>
                  ["place", "address"].indexOf(rs.resultType.toLowerCase()) > -1 && !!rs.vicinity && !!rs.title
              )
              .map(rs => {
                return {
                  id: -1,
                  via: rs.title.replace("<br/>", " "),
                  citta:
                    rs.vicinity.replace("<br/>", " ") ||
                    rs.categoryTitle.replace("<br/>", " "),
                  descrizione:
                    rs.vicinity.replace("<br/>", " ") ||
                    rs.categoryTitle.replace("<br/>", " "),
                  lat: rs.position[0],
                  lon: rs.position[1]
                };
              });
            this[list] = this[list].concat(ft).sort(sortTr);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this[loading] = false));
    },
    filtering(item, str) {
      return (
        item &&
        (item.citta.toLowerCase().indexOf(str.toLowerCase()) > -1 ||
          item.via.toLowerCase().indexOf(str.toLowerCase()) > -1)
      );
    },
    errorMessage(name) {
      const errors = [];
      if (!this.$v.form[name].$dirty) return errors;
      !this.$v.form[name].required && errors.push("Obbligatorio");
      return errors;
    },
    cleanDialogForm() {
      this.$v.$reset();
      this.form = { ...formCampInit };
      this.distanza = null;
    },
    onSaveClick() {
      this.$v.form.$touch();
      if (!this.$v.form.$error) {
        this.$emit("on-save", { ...this.form, distanza: this.distanza });
      }
    },    
  }
};
</script>

<style lang="scss">
.btn-row-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-autocomplete__content {
  z-index: 210 !important;
}
.toolbar-ricerca {
  .v-toolbar__content {
    height: 100% !important;
    .v-expansion-panel__header {
      padding: 0;
      .v-expansion-panel__header__icon {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/ModalNuovaTratta.vue